import { IconProps } from '@models/icons';

function CloseLineIcon({ size = 30, color = '#0D0F11', ...rest }: IconProps) {
  return (
        <svg width={size} height={size}
             className='icon'
             viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg"
             {...rest} >
            <path fillRule="evenodd" clipRule="evenodd"
                  d="M5.80754 22.7782C5.41702 23.1688 5.41702 23.8019 5.80754 24.1924C6.19807 24.583 6.83123 24.583 7.22176 24.1924L14.9999 16.4143L22.7781 24.1924C23.1686 24.583 23.8018 24.583 24.1923 24.1924C24.5828 23.8019 24.5828 23.1688 24.1923 22.7782L16.4141 15.0001L24.1923 7.22188C24.5828 6.83135 24.5828 6.19819 24.1923 5.80766C23.8018 5.41714 23.1686 5.41714 22.7781 5.80766L14.9999 13.5858L7.22176 5.80766C6.83123 5.41714 6.19807 5.41714 5.80754 5.80766C5.41702 6.19819 5.41702 6.83135 5.80754 7.22188L13.5857 15.0001L5.80754 22.7782Z"
                  fill={color}/>
        </svg>
  );
}

export default CloseLineIcon;
